// extracted by mini-css-extract-plugin
export default {"sample":"RespondentsLegend_sample__f34K2","bullet":"RespondentsLegend_bullet__KOHXV"};